<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouteGuardStore } from '@/stores/routeGuardStore'
import BDialog from '@/components/base/BDialog/BDialog.vue'

const { t } = useI18n()
const routeGuardStore = useRouteGuardStore()

const showDialog = computed({
  get: () => routeGuardStore.showDialog,
  set: (value) => {
    if (!value) {
      routeGuardStore.cancelLeave()
    }
  },
})

function handleLeave() {
  routeGuardStore.confirmLeave()
}

function handleCancel() {
  routeGuardStore.cancelLeave()
}
</script>

<template>
  <b-dialog
    v-model="showDialog"
    persistent
    size="small"
  >
    <template #title>{{ t(routeGuardStore.dialogTitle) }}</template>

    <v-card-text>
      {{ t(routeGuardStore.dialogMessage) }}
    </v-card-text>

    <template #footer>
      <v-btn
        variant="text"
        color="primary"
        @click="handleCancel"
      >
        {{ t('common.cancel') }}
      </v-btn>
      <v-btn
        variant="flat"
        color="primary"
        @click="handleLeave"
      >
        {{ t('common.leave') }}
      </v-btn>
    </template>
  </b-dialog>
</template>
